import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { SignService, SignsByTag, Sign } from '../sign.service';

@Component({
  selector: 'sign-browser',
  template: `
    <ng-container *ngFor="let tag of tags | async | keyvalue">
      <h2>{{ tag.key }}</h2>
      <div class="sign-tags">
        <sign-card
          *ngFor="let sign of tag.value"
          routerLink="/sign/{{ sign.id }}"
          [sign]="sign"
        ></sign-card>
      </div>
    </ng-container>
  `,
  styleUrls: ['./sign-browser.component.scss']
})
export class SignBrowserComponent implements OnInit {
  public readonly tags: Observable<SignsByTag> = this.signs.signsByTag;

  constructor(private signs: SignService) {}

  ngOnInit(): void {
    this.signs.load();
  }
}
